import { useHMSWeakSignalIndicator } from "../hms";
import { useLivekitWeakSignalIndicator } from "../livekit";
import { useProviderHook } from "./useProviderHook";

export const useProviderWeakSignalIndicator = () =>
  useProviderHook({
    hms: useHMSWeakSignalIndicator,
    livekit: useLivekitWeakSignalIndicator,
  })();
